var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_526",
    "data-name": "Groupe 526",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41.46,
    height: 36.853,
    viewBox: "0 0 41.46 36.853",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2236",
    "data-name": "Rectangle 2236",
    width: 41.46,
    height: 36.853,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_525",
    "data-name": "Groupe 525",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_706",
    "data-name": "Trac\\xE9 706",
    d: "M17.669,1.769.475,31.547a3.537,3.537,0,0,0,3.063,5.306H37.923a3.537,3.537,0,0,0,3.063-5.306L23.794,1.769a3.537,3.537,0,0,0-6.126,0",
    fill: "#fd3a69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_707",
    "data-name": "Trac\\xE9 707",
    d: "M20.507,10.953h.449a2,2,0,0,1,2,2V22.51a2,2,0,0,1-2,2h-.449a2,2,0,0,1-2-2V12.952a2,2,0,0,1,2-2",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_708",
    "data-name": "Trac\\xE9 708",
    d: "M20.732,27.641a2.224,2.224,0,1,1-2.224,2.224,2.224,2.224,0,0,1,2.224-2.224",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.72973df89742db31c7a8a7ad553c7bc2.svg";
export { ForwardRef as ReactComponent };